export default __webpack_public_path__ + "static/media/hearton.3ab36754.svg";